import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser, faColumns, faRotateLeft, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from 'react-bootstrap';

const DatatableHeader = ({
  titletable,
  titleDisabled,
  searchEnabled,
  globalSearch,
  handleGlobalSearchChange,
  handleGlobalSearchKeyDown,
  handleClearFilters,
  columnFilters,
  sortBy,
  initialSortBy,
  headerActions,
  cols = [],
  toggleColumnVisibility,
  resetLayout,
  searchPosition = 'right'
}) => {
  const hasTitle = !titleDisabled && titletable;
  const showSearchOnLeft = searchPosition === 'left' && !hasTitle;

  const searchBar = searchEnabled && (
    <div className="d-flex align-items-center gap-2 datatable-global-search-container">
      <span className="small fw-semibold text-white">Buscar:</span>
      <div className="position-relative">
        <input
          type="text"
          value={globalSearch}
          onChange={handleGlobalSearchChange}
          onKeyDown={handleGlobalSearchKeyDown}
          className="form-control datatable-global-search-input"
          placeholder="Buscar en todas las columnas..."
          draggable={false}
          onDragStart={e => e.preventDefault()}
          style={{ paddingRight: globalSearch ? '28px' : '12px' }}
        />
        {globalSearch && (
          <button
            type="button"
            className="btn btn-sm position-absolute"
            style={{ right: '4px', top: '50%', transform: 'translateY(-50%)', padding: '0 6px', color: '#888', border: 'none', background: 'transparent' }}
            onClick={() => handleGlobalSearchChange({ target: { value: '' } })}
            title="Limpiar búsqueda"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center w-100 mt-2 gap-3 mb-2 px-2">
      <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-start gap-2">
        {hasTitle && (
          <h5 className="mb-0 text-white datatable-title text-center text-md-start">{titletable}</h5>
        )}
        {showSearchOnLeft && searchBar}
      </div>
      <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-2">
        {headerActions}
        {(globalSearch || Object.keys(columnFilters).some(k => columnFilters[k]) || (sortBy !== (initialSortBy || ''))) && (
          <button
            className="btn d-flex align-items-center justify-content-center hover-shadow datatable-clear-btn"
            onClick={handleClearFilters}
            title="Limpiar filtros y búsqueda"
          >
            <FontAwesomeIcon icon={faEraser} className="me-2" />
            Limpiar Filtros
          </button>
        )}
        {cols.length > 0 && toggleColumnVisibility && (
          <Dropdown align="end">
            <Dropdown.Toggle variant="light" className="btn d-flex align-items-center justify-content-center hover-shadow datatable-clear-btn" style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff', border: 'none' }} title="Mostrar/Ocultar Columnas">
              <FontAwesomeIcon icon={faColumns} className="me-2" />
              Columnas
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
              {cols.map(col => (
                <Dropdown.Item 
                  key={col.key} 
                  as="div" 
                  onClick={(e) => { e.stopPropagation(); toggleColumnVisibility(col.key); }}
                  className="d-flex align-items-center"
                  style={{ cursor: 'pointer' }}
                >
                  <input 
                    type="checkbox" 
                    className="me-2 form-check-input mt-0" 
                    checked={col.isVisible !== false} 
                    readOnly 
                    style={{ cursor: 'pointer' }}
                  />
                  {col.label}
                </Dropdown.Item>
              ))}
              {resetLayout && (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item 
                    as="button" 
                    onClick={(e) => { e.stopPropagation(); resetLayout(); }}
                    className="text-danger d-flex align-items-center"
                    style={{ fontSize: '0.9rem', padding: '8px 16px' }}
                  >
                    <FontAwesomeIcon icon={faRotateLeft} className="me-2" />
                    Restablecer diseño
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
        {!showSearchOnLeft && searchBar}
      </div>
    </div>
  );
};

export default DatatableHeader;
